import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button } from 'antd'
import _ from 'lodash'
import '../../css/customer.scss'
import { Link } from 'react-router-dom'
import PatientFilter from '../../pages/customers/patietn.filter'

const CustomerAction = (props) => {
  var disabledAdd = props.disabledAdd ? props.disabledAdd : false

  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={'200px'}>
          <Row className={'headerText'}>Clinics</Row>
        </Col>
        <Col>&nbsp;</Col>
        <Col style={{ alignSelf: 'center', marginLeft: 'auto' }}>
          <Row justify={'end'} align={'bottom'}>
            <PatientFilter />
            <Link to='/customers/add/customer'>
              <Button disabled={disabledAdd} className={'actionBtn'}>
                ADD
              </Button>
            </Link>
          </Row>
        </Col>
      </Row>
    </>
  )
}

CustomerAction.propTypes = {}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAction)
